import { PlannerRouteDto } from "@core/models/planner-models/planner.model";
import { mapOrderResponseToUIResponse, OrderModel } from "./order.model";
import { DictionarySet } from "@core/models/dictionary.model";
import { differenceInDays } from "@core/utils/date.utils";

export interface RouteModel {
    routeId: number;
    orders: OrderModel[];
    PlanTime: Date;
    PlanEndTime: Date;
    secondDriverId?: number;
    helperDriverId?: number;
    IsPhantomRoute?: boolean;
    IsRouteAsDriverAsistant?: boolean;
    IsMultiDayRoute: boolean;
    IsOneOfFallowingDaysOfMultiDayRoute?: boolean;
    InformationSentToDriverOutdated?: boolean;
}

export function mapRouteDtoToModel(route: PlannerRouteDto, taskTypesDictionary: DictionarySet, orderStatusSet: DictionarySet): RouteModel {
    let informationSentToDriverOutdated = false;
    if (route.ModifyDate && route.LastDriverSync) {
        informationSentToDriverOutdated = new Date(route.ModifyDate) > new Date(route.LastDriverSync);
    }
    return {
        routeId: route.Id,
        helperDriverId: route.HelperDriverId,
        secondDriverId: route.SecondDriverId,
        PlanTime: new Date(route.PlanTime),
        PlanEndTime: new Date(route.PlanEndTime),
        IsMultiDayRoute: isMultiDayRoute(route.PlanTime, route.PlanEndTime),
        orders: mapOrderResponseToUIResponse(route.Orders, taskTypesDictionary, orderStatusSet),
        InformationSentToDriverOutdated: informationSentToDriverOutdated
    }
}

export function isMultiDayRoute(startDate: Date, endDate: Date): boolean {
    return differenceInDays(startDate, endDate) > 0;
}

